import React, { useEffect, useState } from "react";
import api from "api";
import AdminFormalitiesPricingModal from "components/formalities/admin/modals/AdminFormalitiesPricingModal";
import { formatPrice } from 'utils'
import { FiEdit } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";

export default function AdminPagesFormalitiesPricings() {
  const [pricings, setPricings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPricing, setCurrentPricing] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const loadPricings = () => {
    setLoading(true);
    setError(null);
    api
      .get("/admin/formalities/pricings")
      .then(res => setPricings(res.data || []))
      .catch(() => setError("Impossible de charger les tarifs"))
      .finally(() => setLoading(false));
  };
  useEffect(() => { loadPricings(); }, []);
  if (loading) return <div>Chargement des tarifs…</div>;
  if (error) return <div className="text-danger">{error}</div>;
  function openCreate() {
    setCurrentPricing(null);
    setShowModal(true);
  }
  function openEditModal(pricing) {
    setCurrentPricing(pricing);
    setShowModal(true);
  }

  function closeModal(refresh = false) {
    setShowModal(false);
    setCurrentPricing(null);
    if (refresh) loadPricings();
  }

  return (
    <div id="admin-formalities-pricings" className="py-4 pe-5 container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4 pe-2">
        <h1 className="h4 m-0"><span>Tarifs des formalités</span></h1>
        <button className="btn btn-primary" onClick={openCreate}>
          <FaPlus /> Nouveau tarif
        </button>
      </div>

      <div className="container">
        <table className="table table-striped table-hover table-sm">
          <thead>
            <tr>
              <th>Libellé</th>
              <th>Version</th>
              <th className="text-end">Honoraires HT</th>
              <th className="text-end">Honoraires TTC</th>
              <th className="text-end">Frais TTC</th>
              <th className="text-end">Débours TTC</th>
              <th className="text-end">Total TTC</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {pricings.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center text-muted">
                  Aucun tarif disponible
                </td>
              </tr>
            )}
            {pricings.map(p => (
              <tr key={p.fpId}>
                <td>{p.fpLabel}</td>
                <td>{p.fpVersion}</td>
                <td className="text-end">{formatPrice(p.fpHonorairesET)}</td>
                <td className="text-end">{formatPrice(p.fpHonorairesIT)}</td>
                <td className="text-end">
                  {p.fpFeesIT !== undefined ? formatPrice(p.fpFeesIT) : "—"}
                </td>
                <td className="text-end">
                  {p.fpDisbursementsIT !== undefined ? formatPrice(p.fpDisbursementsIT) : "—"}
                </td>
                <td className="text-end">{formatPrice(p.fpTotalPriceIT)}</td>
                <td className="text-center">
                  <FiEdit
                    style={{ cursor: "pointer" }}
                    onClick={e => { e.stopPropagation(); openEditModal(p); }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <AdminFormalitiesPricingModal
          show={showModal}
          pricing={currentPricing}
          onClose={() => closeModal(false)}
          onSaved={() => closeModal(true)}
        />
      )}
    </div>
  );
}
